module.exports = __webpack_public_path__ + "img/service-help.f8e9e69.svg";